function call_ajax(url, method, data, success_cb, error_cb=null, async= true, dataType = null) {

    var options = {
        type: method,
        url: url,
        async: async,
        success: function (response) {
            wait.stop();
            if (typeof success_cb !== 'undefined' || success_cb !== null) {
                success_cb(response);
            }
        },
        error: function (xhr, textStatux, error) {
            // html dans xhr.responseText ou json dans xhr.responseJson
            if (typeof error_cb !== 'undefined' && error_cb !== null) {
                error_cb(xhr, textStatux, error);
            }
            wait.stop();
        }
    };
    if (typeof data !== "undefined" && data !== null) {
        options.data = data;
    }
    if (typeof dataType !== "undefined" && dataType !== null) {
        options.dataType = dataType;
    }
    $.ajax(options);
}

function call_ajax_with_file(url, method, data, success_cb, error_cb, accessToken) {
    var options = {
        type: method,
        url: url,
        processData: false,
        contentType: false,
        timeout: 900000,
        success: function (response) {
            if (typeof success_cb !== 'undefined') {
                success_cb(response);
            }
        },
        error: function (xhr, textStatus, error) {
            if (typeof error_cb !== 'undefined') {
                error_cb(xhr, textStatus, error);
            }
        }
    };
    if (typeof data !== "undefined"){
        options.data = data;
    }

    if (typeof accessToken !== 'undefined' && accessToken !== null) {
        options.headers = {
            'Authorization': 'Bearer ' + accessToken
        };
    }

    console.log('📤 Options AJAX:', options);

    $.ajax(options);
}


function submit_form($form, success_cb, error_cb) {
    const url = $form.attr('action');
    const method = $form.attr('method');
    const data = $form.serialize();
    call_ajax(url, method, data, success_cb, error_cb);

}
